import { BlobServiceClient } from "@azure/storage-blob";

class AzureService {
  constructor(containerUrl, sasToken) {
    if (!containerUrl || !sasToken) {
        console.warn("Container URL and SAS token are required for setting up Azure configuration.");
        this.disabled = true;
     return false;
    }
    this.disabled = true;
    this.containerUrl = containerUrl;
    this.sasToken = sasToken;
    this.blobServiceClient = new BlobServiceClient(`${containerUrl}?${sasToken}`);
  }

  async uploadFile(folderName, file) {
    try {
      const containerClient = this.blobServiceClient.getContainerClient();
      const blobName = `${folderName}/${file.name}`;
      const blockBlobClient = containerClient.getBlockBlobClient(blobName);

      await blockBlobClient.uploadBrowserData(file);
      return `${this.containerUrl}/${blobName}` || null;
    } catch (error) {
      console.error("Error uploading file to Azure:", error);
      throw error;
    }
  }

  async deleteFile(folderName, fileName) {
    if (this.disabled) {
        console.warn("Azure configuration is not set up.");
      return;
    }
    try {
      const containerClient = this.blobServiceClient.getContainerClient();
      const blobName = `${folderName}/${fileName}`;
      const blockBlobClient = containerClient.getBlockBlobClient(blobName);

      await blockBlobClient.delete();
      console.log(`File ${blobName} deleted from Azure`);
    } catch (error) {
      console.error("Error deleting file from Azure:", error);
      throw error;
    }
  }
}

export default AzureService;
